// extracted by mini-css-extract-plugin
module.exports = {"bar":"BorderLinearProgress_bar__25rfG","overutilized":"BorderLinearProgress_overutilized__2xWup","root":"BorderLinearProgress_root__1_brv"};